<template>
  <div
    class="flex w-[78px] h-[14px] rounded-lg cursor-pointer>"
    @click=handleServiceGuideClick>
    <span
    class="font-pretendard font-medium text-[14px] text-textPrimary leading-[83%] tracking-normal align-middle cursor-pointer">
      서비스 가이드
    </span>
  </div>
</template>

<script>
export default {
  methods: {
    handleServiceGuideClick() {
      window.open(
        'https://fluff-tulip-b6d.notion.site/1fac3009e279806f8306c92aa559bfd5?source=copy_link',
        '_blank'
      )
    }
  }
}
</script>
